import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFetchRecommendedBooks = (id) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.get(`books/recommended/${id}`);
		return response.data;
	};
	return useQuery("similarBooks", () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchRecommendedBooks;
